var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterfaceEssential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41667 1.5H13.1667C14.7775 1.5 16.0833 2.80583 16.0833 4.41667V4.41667C16.0833 6.0275 14.7775 7.33333 13.1667 7.33333H4.41667C2.80583 7.33333 1.5 6.0275 1.5 4.41667V4.41667C1.5 2.80583 2.80583 1.5 4.41667 1.5Z",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1667 16.5H4.41667C2.80583 16.5 1.5 15.1941 1.5 13.5833V13.5833C1.5 11.9725 2.80583 10.6666 4.41667 10.6666H13.1667C14.7775 10.6666 16.0833 11.9725 16.0833 13.5833V13.5833C16.0833 15.1941 14.7775 16.5 13.1667 16.5Z",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.165 13.1666C12.935 13.1666 12.7483 13.3533 12.75 13.5833C12.75 13.8133 12.9367 14 13.1667 14C13.3967 14 13.5833 13.8133 13.5833 13.5833C13.5833 13.3533 13.3967 13.1666 13.165 13.1666",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41501 4C4.18501 4 3.99834 4.18667 4.00001 4.41667C4.00001 4.64667 4.18668 4.83333 4.41668 4.83333C4.64668 4.83333 4.83334 4.64667 4.83334 4.41667C4.83334 4.18667 4.64668 4 4.41501 4",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfaceEssential);
export default __webpack_public_path__ + "static/media/Interface, Essential.930e35cedd16a1b9468f0c65998d5ef1.svg";
export { ForwardRef as ReactComponent };